import React, { useEffect, useRef } from 'react';
import { LogEntry } from '../../types';

interface BuildConsoleProps {
  logs: LogEntry[];
  isBuilding?: boolean;
}

const colorMap: Record<string, string> = {
  info:    'var(--text-dim)',
  success: 'var(--success)',
  warn:    'var(--warning)',
  error:   'var(--error)',
  accent:  'var(--accent)',
};

const BuildConsole: React.FC<BuildConsoleProps> = ({ logs, isBuilding }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [logs]);

  return (
    <div
      ref={ref}
      style={{
        background: '#080a0e',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-md)',
        padding: '14px 18px',
        fontFamily: 'var(--font-mono)',
        fontSize: '0.74rem',
        lineHeight: 1.8,
        minHeight: 120,
        maxHeight: 220,
        overflowY: 'auto',
        marginBottom: 20,
      }}
    >
      {logs.map((log, i) => (
        <div key={i} style={{ color: colorMap[log.type] ?? 'var(--text-dim)' }}>
          {log.timestamp && (
            <span style={{ color: 'var(--text-muted)', marginRight: 8 }}>[{log.timestamp}]</span>
          )}
          {log.text}
        </div>
      ))}
      {isBuilding && (
        <div style={{ color: 'var(--accent)' }} className="animate-pulse">█</div>
      )}
    </div>
  );
};

export default BuildConsole;
